import firebase from 'firebase/compat/app';
import "firebase/compat/auth";
import "firebase/compat/database";
import "firebase/compat/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyD7rDNnsbBZmU8uSIjNI7Zo0raZ7KXINdk",
    authDomain: "full-netflix-clone-d5484.firebaseapp.com",
    projectId: "full-netflix-clone-d5484",
    storageBucket: "full-netflix-clone-d5484.appspot.com",
    messagingSenderId: "194233528879",
    appId: "1:194233528879:web:b48e87d14273611df80cda"
};

//initialize the app with these credentials. key to logging into our firebase //
//firestore is the realtime database that we will be using. it allows us to keep track of what the user subscription is. //

const firebaseApp = firebase.initializeApp(firebaseConfig)
const db = firebaseApp.firestore()
const auth = firebase.auth()

export { auth };
export default db; 